import { EMAIL_REGEX, INTERNATIONAL_PHONE_NUMBER_REGEX, URL_REGEX } from 'common/constant/constant';
import ContactDto from 'common/dto-types/contacts/contact-dto';
import { SelectOptionType } from 'utils/react-table';
import * as yup from 'yup';

type ContactFormProps = {
    contact?: ContactDto;
};

export type ContactFormFields = Omit<ContactDto, 'address' | 'contactType' | 'categories' | 'jobTitle'> & {
    address: SelectOptionType;
    contactType: SelectOptionType;
    jobTitle: SelectOptionType;
    categories: SelectOptionType[];
};

export const defaultInitialContactFormValue: ContactFormFields = {
    firstName: '',
    lastName: '',
    contactName: '',
    phone: '',
    email: '',
    secondaryEmail: '',
    avatarUrl: '',
    secondaryAvatarUrl: '',
    preferredLanguages: '',
    note: '',
    facebookProfileUrl: '',
    twitterProfileUrl: '',
    instagramProfileUrl: '',
    youtubeProfileUrl: '',
    linkedinProfileUrl: '',
    tiktokProfileUrl: '',
    websiteUrl: '',
    address: {
        value: 0,
        label: '',
    },
    contactType: {
        value: 0,
        label: '',
    },
    relatedContact: null,
    jobTitle: {
        value: 0,
        label: '',
    },
    categories: [],
    tournaments: [],
    cities: [],
    userGroups: [],
    assignedVenues: [],
    assignedTeams: [],
    location: '',
    ifesId: '',
};

export const contactFormValidationSchema = yup.object().shape({
    contactName: yup
        .string()
        .when(['firstName', 'lastName'], ([firstName, lastName], schema) =>
            firstName || lastName ? schema.notRequired() : schema.required('Please provide a Name for the contact'),
        ),
    phone: yup
        .string()
        .matches(
            INTERNATIONAL_PHONE_NUMBER_REGEX,
            'Please enter a valid phone number with country code (e.g., +1 123 456 7890)',
        ),
    facebookProfileUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    twitterProfileUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    instagramProfileUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    youtubeProfileUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    linkedinProfileUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    tiktokProfileUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    avatarUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    secondaryAvatarUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    websiteUrl: yup.string().matches(URL_REGEX, 'Invalid URL'),
    email: yup.string().matches(EMAIL_REGEX, 'Invalid Email format'),
    secondaryEmail: yup.string().matches(EMAIL_REGEX, 'Invalid Email format'),
});

export default ContactFormProps;
